import { LitElement, html, css, unsafeCSS } from 'lit-element';

import standardValueDisplayStyles from './standard-value-display.scss';
import { StratusStatsCardComponentTemplateModel } from '../../models/components/StratusStatsCardComponentTemplateModel';

export class StandardValueDisplay extends LitElement {
    private _data: StratusStatsCardComponentTemplateModel;
    private _onClick: Function;
    private _playlistClickThrough: boolean;

    constructor(data: StratusStatsCardComponentTemplateModel, playlistClickThrough: boolean, onClick: Function) {
        super();

        this._data = data;
        this._onClick = onClick;
        this._playlistClickThrough = playlistClickThrough;
    }

    static get styles() {
        return [
            css`${unsafeCSS(standardValueDisplayStyles)}`
        ]
    }

    firstUpdated() {

    }

    render() {
        return [
            html`
                <div class="row" style="--base-color:${this._data.baseColor}">
                        <div class="heading">${this._data.heading}</div>
                        <div @click="${async (event) => await this._onClick(event, this._data.baseMetric.metricId, this._data.heading)}" 
                            class="value ${(this._playlistClickThrough ? "clickable" : "")}"
                            title="${this._data.heading}">${this._data.baseMetric.displayValue}${this._data.baseMetric.percentageValue ? `(${this._data.baseMetric.percentageValue})` : ''}</div>                    
                </div>           
            `
        ]
    }
}

window.customElements.define('standard-value-display', StandardValueDisplay as any);